import { render, staticRenderFns } from "./CheckoutTermsAndConditionsAndWarnings.vue?vue&type=template&id=acc6ead6&scoped=true&"
import script from "./CheckoutTermsAndConditionsAndWarnings.vue?vue&type=script&lang=js&"
export * from "./CheckoutTermsAndConditionsAndWarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc6ead6",
  null
  
)

export default component.exports